import Vue from "vue";
import Router from "vue-router";
import Login from "@/components/Login";
import Home from "@/components/Home";
import HomePage from "@/components/HomePage"
import UserMana from "@/components/UserMana";
import JDSLoan from "@/components/JDSLoan";
import JTKLoan from "@/components/JTKLoan";
import GSCSH_month from "@/components/GSCSH_month";
import TaxForm from "@/components/EndYearAdj/TaxForm";
import RaiseDeclaration from "@/components/EndYearAdj/RaiseDeclaration";
import AttendanceMana from "@/components/AttendanceMana";
import EmpList from "@/components/EmpList";
import EmpListResign from "@/components/EmpListResign";
import EmpPDF from "@/components/EmpPDF";
import CompanyInfo from "@/components/CompanyInfo";
import LaborInsInfo from "@/components/LaborInsInfo";
import LaborInsAccount from "@/components/LaborInsAccount";
import EmpIns1 from "@/components/EmpIns/EmpIns1";
import EmpIns2 from "@/components/EmpIns/EmpIns2";
import EmpIns3 from "@/components/EmpIns/EmpIns3";
import EmpIns4 from "@/components/EmpIns/EmpIns4";
import EmpIns5 from "@/components/EmpIns/EmpIns5";
import EmpIns6 from "@/components/EmpIns/EmpIns6";
import EmpIns7 from "@/components/EmpIns/EmpIns7";
import EmpIns8 from "@/components/EmpIns/EmpIns8";
import EmpIns9 from "@/components/EmpIns/EmpIns9";
import EmpIns10 from "@/components/EmpIns/EmpIns10";
import EmpIns12 from "@/components/EmpIns/EmpIns12";
import EmpIns13 from "@/components/EmpIns/EmpIns13";
import EmpIns14 from "@/components/EmpIns/EmpIns14";
import EmpInsInquiry from "@/components/EmpIns/EmpInsInquiry";
import EmpIns3NewSubmission from "@/components/EmpIns/EmpIns3NewSubmission";
import EmpIns3NewSummary from "@/components/EmpIns/EmpIns3NewSummary";
import EmpInsMyNumberGroup from "@/components/EmpIns/EmpInsMyNumberGroup";
import EmpInsMyNumberSummary from "@/components/EmpIns/EmpInsMyNumberSummary";
import EmpInsAuthorityLetter from "@/components/EmpIns/EmpInsAuthorityLetter";
import EmpInsChildcareLeave from "@/components/EmpIns/EmpInsChildcareLeave";
import EmpInsNursingLeave from "@/components/EmpIns/EmpInsNursingLeave";
import EmpInsElderly from "@/components/EmpIns/EmpInsElderly";
import EmpInsPaymentOption from "@/components/EmpIns/EmpInsPaymentOption";
import EmpInsRemoveBenefit from "@/components/EmpIns/EmpInsRemoveBenefit";
import EmpInsHome from "@/components/EmpIns/EmpInsHome";
import EmpInsSteps from "@/components/EmpIns/EmpInsSteps";
import HealthInsHome from "@/components/HealthIns/HealthInsHome";
import HealthIns1 from "@/components/HealthIns/HealthIns1";
import HealthIns2 from "@/components/HealthIns/HealthIns2";
import HealthIns3 from "@/components/HealthIns/HealthIns3";
import HealthIns4 from "@/components/HealthIns/HealthIns4";
import HealthIns5 from "@/components/HealthIns/HealthIns5";
import Childcare_Application from "@/components/HealthIns/Childcare_Application";
import Childcare_Application_Salary_Change from "@/components/HealthIns/Childcare_Application_Salary_Change";
import SuspensionNotice from "@/components/HealthIns/SuspensionNotice";
import InsNameChange from "@/components/HealthIns/InsNameChange";
import InsDisqualifyNotice from "@/components/HealthIns/InsDisqualifyNotice";
import Register from "@/components/Register";
import RegisterSelect from "@/components/RegisterSelect";
import Forget from "@/components/Forget";
import Check from "@/components/Check";
import PasswordReset from "@/components/PasswordReset";
import PensionAdmin from "@/components/PensionAdmin";
import PensionBasic from "@/components/PensionBasic";
import InsQualifyNotice from "@/components/HealthIns/InsQualifyNotice";
import PensionReissue from "@/components/SocialIns/PensionReissue";
import SocialInsSteps from "@/components/SocialIns/SocialInsSteps";
import AttoneryPower from "@/components/SocialIns/AttoneryPower";
import UserHome from "@/components/UserHome";
import FileList from "@/components/FileList";
import Calculator from "@/components/Website/Calculator";
import Salary from "@/components/Salary/Salary";
import TaxBook from "@/components/EndYearAdj/TaxBook";
import EndYearAdjHome from "@/components/EndYearAdj/EndYearAdjHome";
import TaxFormLeave from "@/components/EndYearAdj/TaxFormLeave";
import InsDeclaration from "@/components/EndYearAdj/InsDeclaration";
import BasicDeclaration from "@/components/EndYearAdj/BasicDeclaration";
import NextDeclaration from "@/components/EndYearAdj/NextDeclaration";

Vue.use(Router);

export default new Router({
    // mode: 'history',
    // components: {foreignArea},
    routes: [{
        path: "/",
        name: "ログイン",
        hidden: true,
        component: Login,
        meta: {
            localeName: "router.login",
        },
    },
    {
        path: "/registerSelect",
        name: "会員プラン選択",
        hidden: true,
        component: RegisterSelect,
        meta: {
            keepAlive: true,
            localeName: "router.registerSelect",
        },
    },
    {
        path: "/register",
        name: "会員登録",
        hidden: true,
        component: Register,
        meta: {
            keepAlive: true,
            localeName: "router.register",
        },
    },
    {
        path: "/check",
        name: "checkCode",
        hidden: true,
        component: Check,
        meta: {
            keepAlive: true,
            localeName: "router.check",
        },
    },
    {
        path: "/forget",
        name: "forger",
        hidden: true,
        component: Forget,
        meta: {
            keepAlive: true,
            localeName: "router.forget",
        },
    },
    {
        path: "/passwordReset",
        name: "PWReset",
        hidden: true,
        component: PasswordReset,
        meta: {
            keepAlive: true,
            localeName: "router.passwordReset",
        },
    },
    {
        path: "/website/calculator",
        name: "News",
        hidden: true,
        component: Calculator,
        meta: {
            keepAlive: true,
            localeName: "router.website.calculator",
        },
    },
    {
        path: "/home",
        name: "ホーム",
        meta: {
            localeName: "",
        },
        component: Home,
        hidden: true,
    },
    {
        path: "/home",
        component: Home,
        name: "基本台帳",
        iconCls: "el-icon-collection",
        meta: {
            localeName: "router.basic.title",

        },
        iconCls: "el-icon-collection",
        children: [{
            path: "/companyInfo",
            name: "会社情報",
            component: CompanyInfo,
            meta: {
                localeName: "router.basic.company",
                keepAlive: true,
                type: 'login',
            },
        },
        {
            path: "/homePage",
            name: "ホームページ",
            component: HomePage,
            hidden: true,
            meta: {
                localeName: "router.basic.homePage",
                keepAlive: true,
                type: 'login',
            },
        },
        {
            path: "/fileList",
            name: "書類一覧",
            hidden: true,
            component: FileList,
            meta: {
                keepAlive: true,
                localeName: "router.basic.fileList",
                type: 'login',
            },
        },
        ],
    },
    {
        path: "/home",
        component: Home,
        name: "人事管理",
        iconCls: "el-icon-user",
        meta: {
            localeName: "router.hr.title",
        },
        children: [{
            path: "/empList",
            name: "社員リスト",
            component: EmpList,
            meta: {
                keepAlive: false,
                localeName: "router.hr.list",
                type: 'login',
            },
        },
        {
            path: "/empPDF",
            name: "労働者名簿印刷",
            component: EmpPDF,
            meta: {
                // keepAlive: true,
                localeName: "router.hr.empPDF",
                type: 'login',
            },
        },
        {
            path: "/empListResign",
            name: "退職者情報",
            component: EmpListResign,
            meta: {
                keepAlive: false,
                localeName: "router.hr.EmpListResign",
                type: 'login',
            },
        },
        ],
    },

    {
        path: "/home",
        component: Home,
        name: "給与明細",
        meta: {
            localeName: "router.cacl.salary",

        },
        children: [{
            path: "/salary",
            iconCls: "el-icon-coin",
            name: "給与明細",
            meta: {
                localeName: "router.cacl.salary",
                type: 'login',

            },
            component: Salary,
        },
        ],
    },


    {
        path: "/home",
        component: Home,
        name: "労働保険",
        meta: {
            localeName: "router.laborIns.title",
        },
        iconCls: "el-icon-suitcase",
        children: [{
            path: "/laborInsInfo",
            name: "労働保険情報",
            component: LaborInsInfo,
            meta: {
                localeName: "router.basic.laborIns",
                // keepAlive: true,
                type: 'login',
            },
        },
        {
            path: "/laborInsAccount",
            name: "口座振替",
            component: LaborInsAccount,
            meta: {
                localeName: "router.laborIns.labor_ins_account",
                // keepAlive: true,
                type: 'login',
            },
        },
        ],
    },
    {
        path: "/home",
        component: Home,
        name: "社会保険",
        meta: {
            localeName: "router.health.title",
        },
        iconCls: "el-icon-first-aid-kit",
        children: [
            {
                path: "/SocialInsSteps",
                name: "",
                component: SocialInsSteps,
                meta: {
                    localeName: "router.social.social_ins_steps",
                    keepAlive: true,
                    type: 'login',
                },
            },
            {
                path: "/HealthInsHome",
                name: "健康保険ホームページ",
                component: HealthInsHome,
                meta: {
                    localeName: "router.health.HealthInsHome",
                    keepAlive: true,
                    type: 'login',
                },
            },
            {
                path: "/PensionReissue",
                name: "",
                component: PensionReissue,
                hidden: true,
                meta: {
                    localeName: "router.social.pension_reissue",
                    keepAlive: true,
                    type: 'login',
                },
            },
            {
                path: "/AttoneryPower",
                name: "",
                component: AttoneryPower,
                hidden: true,
                meta: {
                    localeName: "router.social.attorney_power",
                    keepAlive: true,
                    type: 'login',
                },
            },
            {
                path: "/HealthIns1",
                name: "厚生年金保険新規適用届",
                component: HealthIns1,
                hidden: true,
                meta: {
                    localeName: "router.health.HealthIns1",
                    keepAlive: true,
                    type: 'login',
                },
            },
            {
                path: "/HealthIns2",
                name: "健康保険2",
                component: HealthIns2,
                hidden: true,
                meta: {
                    localeName: "router.health.HealthIns2",
                    keepAlive: true,
                    type: 'login',
                },
            },
            {
                path: "/HealthIns3",
                name: "健康保険3",
                component: HealthIns3,
                hidden: true,
                meta: {
                    localeName: "router.health.HealthIns3",
                    keepAlive: true,
                    type: 'login',
                },
            },
            {
                path: "/HealthIns4",
                name: "健康保険4",
                component: HealthIns4,
                hidden: true,
                meta: {
                    localeName: "router.health.HealthIns4",
                    keepAlive: true,
                    type: 'login',
                },
            }, {
                path: "/HealthIns5",
                name: "健康保険5",
                component: HealthIns5,
                hidden: true,
                meta: {
                    localeName: "router.health.HealthIns5",
                    keepAlive: true,
                    type: 'login',
                },
            }, {
                path: "/Childcare_Application",
                name: "健康保険5",
                component: Childcare_Application,
                hidden: true,
                meta: {
                    localeName: "router.health.Childcare_Application",
                    keepAlive: true,
                    type: 'login',
                },
            }, {
                path: "/Childcare_Application_Salary_Change",
                name: "健康保険5",
                component: Childcare_Application_Salary_Change,
                hidden: true,
                meta: {
                    localeName: "router.health.Childcare_Application_Salary_Change",
                    keepAlive: true,
                    type: 'login',
                },
            },
            {
                path: "/SuspensionNotice",
                name: "健康保険4",
                component: SuspensionNotice,
                hidden: true,
                meta: {
                    localeName: "router.health.SuspensionNotice",
                    keepAlive: true,
                    type: 'login',
                },
            },
            {
                path: "/InsNameChange",
                name: "健康保険5",
                component: InsNameChange,
                hidden: true,
                meta: {
                    localeName: "router.health.InsNameChange",
                    keepAlive: true,
                    type: 'login',
                },
            },
            {
                path: "/InsDisqualifyNotice",
                name: "健康保険6",
                component: InsDisqualifyNotice,
                hidden: true,
                meta: {
                    localeName: "router.health.InsDisqualifyNotice",
                    keepAlive: true,
                    type: 'login',
                },
            },
            {
                path: "/InsQualifyNotice",
                name: "健康保険7",
                component: InsQualifyNotice,
                hidden: true,
                meta: {
                    localeName: "router.health.InsQualifyNotice",
                    keepAlive: true,
                    type: 'login',
                },
            },
        ],
    },
    {
        path: "/home",
        component: Home,
        name: "雇用保険",
        meta: {
            localeName: "router.empIns.title",
        },
        iconCls: "el-icon-s-custom",
        children: [{
            path: "/empInsSteps",
            name: "機能一覧",
            component: EmpInsSteps,
            meta: {
                localeName: "雇用保険流れ",
                keepAlive: true,
                type: 'login',
            },
        },
        {
            path: "/empInsHome",
            name: "機能一覧",
            component: EmpInsHome,
            meta: {
                localeName: "router.empIns.empInsHome",
                keepAlive: true,
                type: 'login',
            },
        },
        {
            path: "/empIns1",
            name: "各種変更届",
            component: EmpIns1,
            hidden: true,
            meta: {
                localeName: "router.empIns.empIns1",
                keepAlive: true,
                type: 'login',

            },
        },
        {
            path: "/empIns2",
            name: "事業所設置",
            component: EmpIns2,
            hidden: true,
            meta: {
                localeName: "router.empIns.empIns2",
                keepAlive: true,
                type: 'login',

            },
        },
        {
            path: "/empIns3",
            name: "雇用保険被保険者離職票再交付申請書",
            component: EmpIns3,
            hidden: true,
            meta: {
                localeName: "router.empIns.empIns3",
                keepAlive: true,
                type: 'login',
            },
        },
        {
            path: "/empIns4",
            name: "被保険者",
            component: EmpIns4,
            hidden: true,
            meta: {
                localeName: "router.empIns.empIns4",
                keepAlive: true,
                type: 'login',
            },
        },
        ],
    },
    {
        path: "/home",
        component: Home,
        name: "報酬月額",
        meta: {
            localeName: "router.sarary.title",

        },
        iconCls: "el-icon-document",
        children: [
            {
                path: "/PensionBasic",
                name: "",
                component: PensionBasic,
                meta: {
                    localeName: "router.sarary.pensionbasic",
                },
            },
            {
                path: "/PensionAdmin",
                name: "",
                component: PensionAdmin,
                meta: {
                    localeName: "router.sarary.pensionadmin",
                },
            },
        ],
    },
    {
        path: "/home",
        component: Home,
        name: "年末調整",
        hidden: true,
        meta: {
            localeName: "router.adj.title",
            roles: ['管理員']
        },
        iconCls: "el-icon-s-check",
        children: [
            {
                path: "/endYearAdjHome",
                name: "年末調整機能一覧",
                component: EndYearAdjHome,
                meta: {
                    localeName: "router.adj.EndYearAdjHome",
                    keepAlive: true,
                    type: 'login',
                },
            },
            {
                path: "/taxForm",
                name: "源泉徴収票",
                component: TaxForm,
                meta: {
                    localeName: "router.adj.taxForm",
                    keepAlive: true,
                    type: 'login',
                },
            },
            {
                path: "/taxBook",
                name: "源泉徴収簿",
                component: TaxBook,
                meta: {
                    localeName: "router.adj.taxBook",
                    keepAlive: true,
                    type: 'login',
                },
                hidden: true,
            },
            {
                path: "/taxFormLeave",
                name: "退職所得の源泉徴収票",
                component: TaxFormLeave,
                meta: {
                    localeName: "router.adj.taxFormLeave",
                    keepAlive: true,
                    type: 'login',
                },
                hidden: true,
            },
            {
                path: "/insDeclaration",
                name: "保険料控除申告書",
                component: InsDeclaration,
                meta: {
                    localeName: "router.adj.insDeclaration",
                    type: 'login',
                },
                hidden: true,
            },
            {
                path: "/basicDeclaration",
                name: "基礎控除申告書",
                component: BasicDeclaration,
                meta: {
                    localeName: "router.adj.basicDeclaration",
                    keepAlive: true,
                    type: 'login',
                },
                hidden: true,
            },
            {
                path: "/nextDeclaration",
                name: "翌年分撫養控除申告書",
                component: NextDeclaration,
                meta: {
                    localeName: "router.adj.nextDeclaration",
                    keepAlive: true,
                    type: 'login',
                },
                hidden: true,
            },
            {
                path: "/RaiseDeclaration",
                name: "扶養控除申告",
                component: RaiseDeclaration,
                meta: {
                    localeName: "router.adj.declaration",
                    keepAlive: true,
                    type: 'login',
                },
            },

        ],
    },
    {
        path: "/home",
        component: Home,
        hidden: true,
        name: "勤怠管理",
        meta: {
            localeName: "router.attendance.title",
        },
        children: [{
            path: "/attendance",
            iconCls: "fa fa-bus",
            name: "勤怠管理",
            meta: {
                localeName: "router.attendance.manage",
            },
            component: AttendanceMana,
        },
        {
            path: "/userHome",
            iconCls: "fa fa-bus",
            name: "個人ページ",
            meta: {
                localeName: "router.attendance.userHome",
            },
            component: UserHome,
        },
        ],
    },
    {
        path: "/home",
        component: Home,
        hidden: true,
        name: "ユーザー管理",
        meta: {
            localeName: "router.user.title",
            roles: ['管理員']
        },
        children: [{
            path: "/user",
            iconCls: "el-icon-s-tools",
            name: "ユーザー管理",
            meta: {
                localeName: "router.user.manage",
            },
            component: UserMana,
        },
        ],
    },
    {
        path: "/home",
        component: Home,
        hidden: true,
        name: "詳細情報",
        meta: {
            localeName: "router.detail.title",
        },
        children: [
            {
                path: "/empIns5",
                name: "個人番号登録・変更届",
                component: EmpIns5,
                meta: {
                    localeName: "router.detail.empIns5",
                },
            },
            {
                path: "/empIns6",
                name: "再就職手当支給申請書",
                component: EmpIns6,
                meta: {
                    localeName: "router.detail.empIns6",
                },
            },
            {
                path: "/empIns7",
                name: "雇用保険適用事業所廃止届",
                component: EmpIns7,
                meta: {
                    localeName: "router.detail.empIns7",
                },
            },
            {
                path: "/empIns8",
                name: "雇用保険適用除外申請書",
                component: EmpIns8,
                meta: {
                    localeName: "router.detail.empIns8",
                },
            },
            {
                path: "/empIns9",
                name: "雇用保険被保険者資格喪失届・氏名変更届",
                component: EmpIns9,
                meta: {
                    localeName: "router.detail.empIns9",
                },
            },
            {
                path: "/empIns10",
                name: "雇用保険被保険者資格喪失届光ディスク等提出用総括票",
                component: EmpIns10,
                meta: {
                    localeName: "router.detail.empIns10",
                },
            },
            // {
            //     path: "/empIns11",
            //     name: "雇用保険被保険者資格取得届光ディスク等提出用総括票に係る対象者名簿",
            //     component: EmpIns11,
            //     meta: {
            //         localeName: "router.detail.empIns11",
            //     },
            // },
            {
                path: "/empIns12",
                name: "雇用保険被保険者転勤届",
                component: EmpIns12,
                meta: {
                    localeName: "router.detail.empIns12",
                },
            },
            {
                path: "/empIns13",
                name: "雇用保険の被保険者である外国人に係る届出",
                component: EmpIns13,
                meta: {
                    localeName: "router.detail.empIns13",
                },
            },
            {
                path: "/empIns14",
                name: "雇用保険の被保険者ではない外国人に係る届出",
                component: EmpIns14,
                meta: {
                    localeName: "router.detail.empIns14",
                },
            }, {
                path: "/empInsInquiry",
                name: "雇用保険被保険者資格取得届出確認照会票",
                component: EmpInsInquiry,
                meta: {
                    localeName: "雇用保険被保険者資格取得届出確認照会票",
                },
            }, {
                path: "/empIns3NewSubmission",
                name: "雇用保険被保険者資格取得届（連記式）個人別票",
                component: EmpIns3NewSubmission,
                meta: {
                    localeName: "雇用保険被保険者資格取得届（連記式）個人別票",
                },
            }, {
                path: "/empIns3NewSummary",
                name: "雇用保険被保険者資格取得届（連記式）総括票",
                component: EmpIns3NewSummary,
                meta: {
                    localeName: "雇用保険被保険者資格取得届（連記式）総括票",
                },
            }, {
                path: "/empInsAuthorityLetter",
                name: "雇用保険被保険者関係届出-事務等代理人選任・解任届",
                component: EmpInsAuthorityLetter,
                meta: {
                    localeName: "雇用保険被保険者関係届出-事務等代理人選任・解任届",
                },
            }, {
                path: "/empInsMyNumberGroup",
                name: "個人番号登録届出書（連記式）個人別票",
                component: EmpInsMyNumberGroup,
                meta: {
                    localeName: "個人番号登録届出書（連記式）個人別票",
                },
            }, {
                path: "/empInsMyNumberSummary",
                name: "個人番号登録届出書（連記式）総括票",
                component: EmpInsMyNumberSummary,
                meta: {
                    localeName: "個人番号登録届出書（連記式）総括票",
                },
            }, {
                path: "/empInsChildcareLeave",
                name: "育児休業給付受給資格確認票・（初回）育児休業給付金支給申請書",
                component: EmpInsChildcareLeave,
                meta: {
                    localeName: "育児休業給付受給資格確認票・（初回）育児休業給付金支給申請書",
                },
            }, {
                path: "/empInsNursingLeave",
                name: "介護休業給付金支給申請書",
                component: EmpInsNursingLeave,
                meta: {
                    localeName: "介護休業給付金支給申請書",
                },
            }, {
                path: "/empInsElderly",
                name: "高年齢雇用継続給付受給資格確認票・（初回）高年齢雇用継続給付支給申請書",
                component: EmpInsElderly,
                meta: {
                    localeName: "高年齢雇用継続給付受給資格確認票・（初回）高年齢雇用継続給付支給申請書",
                },
            }, {
                path: "/empInsPaymentOption",
                name: "払渡希望金融機関指定・変更届",
                component: EmpInsPaymentOption,
                meta: {
                    localeName: "払渡希望金融機関指定・変更届",
                },
            }, {
                path: "/empInsRemoveBenefit",
                name: "未支給失業等給付請求書",
                component: EmpInsRemoveBenefit,
                meta: {
                    localeName: "未支給失業等給付請求書",
                },
            },
        ],
    },
    {
        path: "/home",
        component: Home,
        name: "便利ツール",
        meta: {
            localeName: "router.cacl.title",
        },
        iconCls: "el-icon-star-off",
        children: [{
            path: "/FileList",
            name: "書類一覧",
            meta: {
                localeName: "router.cacl.fileList",
                keepAlive: true,
                type: 'login',
            },
            component: FileList,
        }, {
            path: "/calculator",
            name: "税金等計算",
            meta: {
                localeName: "router.cacl.calculator",
                keepAlive: true,
                type: 'login',
            },
            component: Calculator,
        },
        {
            path: "/JDSLoan",
            name: "自動車ローン",
            meta: {
                localeName: "router.cacl.jdsloan",
                roles: ['管理員'],
                keepAlive: true,
                type: 'login',
            },
            hidden: true,
            component: JDSLoan,
        },
        {
            path: "/JTKLoan",
            name: "住宅ローン",
            meta: {
                localeName: "router.cacl.jtkloan",
                roles: ['管理員'],
                keepAlive: true,
                type: 'login',
            },
            hidden: true,
            component: JTKLoan,
        },
        {
            path: "/GSCSH_month",
            name: "源泉徴収税（月額）",
            meta: {
                localeName: "router.cacl.gscsh_month",
                roles: ['管理員'],
                keepAlive: true,
                type: 'login',
            },
            hidden: true,
            component: GSCSH_month,
        },
        ],
    },
    ],
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
});


// WEBPACK FOOTER //
// ./src/router/index.js